"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icon_1 = require("@ant-design/icons/lib/components/Icon");
var SvgCalendarReturnFilledSvg = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M5 3a1 1 0 0 1 2 0v1h6V3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1zm4.518 2.801a5.25 5.25 0 1 1-2.177 9.57.75.75 0 1 1 .83-1.25 3.75 3.75 0 1 0-.54-5.805l-.554.707.59-.006a.75.75 0 0 1 .013 1.5l-2.5.023a.75.75 0 0 1-.757-.743L4.4 7.266a.75.75 0 1 1 1.5-.014l.008.831.572-.73a1 1 0 0 1 .06-.068A5.25 5.25 0 0 1 9.519 5.8", clipRule: "evenodd" }))); };
var SvgCalendarReturnFilled = function (props) { return (React.createElement(Icon_1.default, __assign({ component: SvgCalendarReturnFilledSvg }, props))); };
exports.default = SvgCalendarReturnFilled;
